import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { Footer } from './Footer';

export class Layout extends Component {
  static displayName = Layout.name;

  changeBackground = (color) => {
   return {paddingRight: 0, paddingLeft: 0, marginRight: 'auto', marginLeft: 'auto', backgroundColor: color}
  }

  resetPropsInSessionStorage = () => {
    sessionStorage.setItem("dropdownOpen", "false");
    sessionStorage.setItem("dropdownText", "Scegli il Livello 2");
    sessionStorage.setItem("showLivelli1", "true");
    sessionStorage.setItem("Livelli1", JSON.stringify([]));
    sessionStorage.setItem("livelli1IndexSelected", "true");
    sessionStorage.setItem("showLivelli2", "false");
    sessionStorage.setItem("Livelli2", JSON.stringify([]));
    sessionStorage.setItem("locInPage", "Livelli1");
  }
  
  render () {
    const normal = (
      <div>
        <NavMenu history={this.props.history} role={this.props.role} setRole={this.props.setRole}/>
        <Container style={this.changeBackground('#ffffff')} fluid>
          {this.props.children}
        </Container>
        
      </div> 
    );

    const login = (
      <div style={{height: '100%'}}>
        <Container style={this.changeBackground('#011e41')} fluid>
          {this.props.children}
        </Container>
      </div> 
    );

    const pathname = this.props.history.location.pathname;

    return (
      <div>
        {pathname === "/login" ? login : normal}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout.js